export default "__VITE_ASSET__3b388cfd__"